import { render, staticRenderFns } from "./product-modal.vue?vue&type=template&id=0c9b28b8"
import script from "./product-modal.vue?vue&type=script&lang=ts"
export * from "./product-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c9b28b8')) {
      api.createRecord('0c9b28b8', component.options)
    } else {
      api.reload('0c9b28b8', component.options)
    }
    module.hot.accept("./product-modal.vue?vue&type=template&id=0c9b28b8", function () {
      api.rerender('0c9b28b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/product-modal.vue"
export default component.exports